import type { VideoType as PlayerVideoType } from '@kinopoisk-int/filmoscope';

import { VideoType } from '../../types/instance';

export const PLAYER_VIDEO_TYPES_TO_LOCAL: Record<PlayerVideoType, VideoType> = {
    VOD: VideoType.vod,
    EVENT: VideoType.event,
    LIVE: VideoType.live,
};

export const AUTO_PLAY_ERROR = 'PLAY_ERROR';

export const PLAYBACK_RATE_RANGE = { max: Infinity, min: 0 };
